import { __extends } from "tslib";
import * as React from 'react';
import * as propTypes from 'prop-types';
import { InternalSelectTile } from './internal-select-tile';
import { Text } from '../../new-libby/core/typography';
import { namespacedClassnames } from '../../common';
export var SelectTileGroupKey = 'select-tile-group';
export var SelectTilePadding;
(function (SelectTilePadding) {
    SelectTilePadding["NONE"] = "0";
    SelectTilePadding["SMALL"] = "14px";
    SelectTilePadding["MEDIUM"] = "24px";
})(SelectTilePadding || (SelectTilePadding = {}));
var SelectTile = /** @class */ (function (_super) {
    __extends(SelectTile, _super);
    function SelectTile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectTile.prototype.render = function () {
        var props = this.props;
        var _a = this.context.selectTileGroup, selectedValue = _a.selectedValue, onChange = _a.onChange;
        var checked = ("" + props.value).toUpperCase() === ("" + selectedValue).toUpperCase();
        var onSelect = onChange.bind(null, props.value);
        var padding = props.padding ? props.padding : SelectTilePadding.NONE;
        var internalTile = (React.createElement(InternalSelectTile, { checked: checked, onSelect: onSelect, disabled: props.disabled, padding: padding }, props.children));
        var maybeLabel = props.label ? (React.createElement(Text, { className: 'select-tile-label', type: 'ts', color: 't40' }, props.label)) : null;
        return (React.createElement("div", { className: namespacedClassnames('select-tile', { checked: checked }), "data-value": "" + props.value },
            internalTile,
            maybeLabel));
    };
    SelectTile.contextTypes = {
        selectTileGroup: propTypes.object
    };
    return SelectTile;
}(React.PureComponent));
export { SelectTile };
// tslint:disable-next-line:max-classes-per-file
var SelectTileGroup = /** @class */ (function (_super) {
    __extends(SelectTileGroup, _super);
    function SelectTileGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectTileGroup.prototype.getChildContext = function () {
        var _a = this.props, selectedValue = _a.selectedValue, onChange = _a.onChange;
        return { selectTileGroup: { selectedValue: selectedValue, onChange: onChange } };
    };
    SelectTileGroup.prototype.render = function () {
        var props = this.props;
        return React.createElement("div", { className: namespacedClassnames(SelectTileGroupKey) }, props.children);
    };
    SelectTileGroup.childContextTypes = {
        selectTileGroup: propTypes.object
    };
    return SelectTileGroup;
}(React.PureComponent));
export { SelectTileGroup };
//# sourceMappingURL=index.js.map